module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b2838fd316505dfed435317ef645bc96.png";